import React from 'react';
import { AppButton } from '../ui';
import KkpPlanningToolsMenu from './KkpPlanningToolsMenu';
import '../../styles/kkp-planning-page.scss';

/**
 * Barre d’actions page : boutons visibles + menu ⋯ réservé aux import/export.
 *
 * @param {Array<{
 *   key: string,
 *   label: string,
 *   icon?: string,
 *   onClick: () => void,
 *   disabled?: boolean,
 *   loading?: boolean,
 *   variant?: string,
 * }>} actions
 * @param {Array} menuItems items passés à KkpPlanningToolsMenu (import/export)
 * @param {React.ReactNode} children contenu libre (ex. badge statut) avant les boutons
 */
const KkpPlanningPageActions = ({
  actions = [],
  menuItems = [],
  children = null,
}) => {
  if (!actions.length && !menuItems.length && !children) return null;

  return (
    <div className="kkp-planning-tools">
      {children}
      {actions.map((action) => (
        <AppButton
          key={action.key}
          size="sm"
          variant={action.variant || 'outline-secondary'}
          icon={action.icon}
          iconWidth={16}
          onClick={action.onClick}
          disabled={action.disabled}
          loading={action.loading}
          className="kkp-planning-tools__action"
        >
          {action.label}
        </AppButton>
      ))}
      <KkpPlanningToolsMenu items={menuItems} />
    </div>
  );
};

export default KkpPlanningPageActions;
